<div class="wrapper-page wrapper-my-list">
<!--  <tl-header></tl-header>-->
  <div class="wrapper-header-my-lists">
    <div class="header-my-lists">
      <span>{{'PRIVACY_POLICY.text1' | translate}}</span>
    </div>
  </div>
  <div class="wrapper-content-my-lists favorite-lists">
    <div class="content-my-lists">
      <div class="content-privacy-policy">
        <span class="title-text">{{'PRIVACY_POLICY.text2' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text3' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text4' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text5' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text6' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text7' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text8' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text9' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text10' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text11' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text12' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text13' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text14' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text15' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text16' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text17' | translate}}</p>
        <ul>
          <li>{{'PRIVACY_POLICY.text18' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text19' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text21' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text22' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text23' | translate}}</li>
        </ul>
        <p>{{'PRIVACY_POLICY.text24' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text25' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text26' | translate}}</p>
        <ul>
          <li>{{'PRIVACY_POLICY.text27' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text28' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text29' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text30' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text31' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text32' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text33' | translate}}</li>
        </ul>
        <span class="title-text"><li>{{'PRIVACY_POLICY.text34' | translate}}</li></span>
        <p>{{'PRIVACY_POLICY.text35' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text36' | translate}}</p>
        <ul>
          <li>{{'PRIVACY_POLICY.text37' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text38' | translate}}</li>
        </ul>
        <p>{{'PRIVACY_POLICY.text39' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text40' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text41' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text42' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text43' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text44' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text45' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text46' | translate}}</p>
        <ul>
          <li>{{'PRIVACY_POLICY.text47' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text48' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text49' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text50' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text51' | translate}}</li>
        </ul>
        <p>{{'PRIVACY_POLICY.text52' | translate}}</p>
        <ul>
          <li>{{'PRIVACY_POLICY.text53' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text54' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text55' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text56' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text57' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text58' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text59' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text61' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text62' | translate}}</li>
        </ul>
        <p>{{'PRIVACY_POLICY.text63' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text64' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text65' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text66' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text67' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text68' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text69' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text71' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text72' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text73' | translate}}</p>
        <ul>
          <li>{{'PRIVACY_POLICY.text74' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text75' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text76' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text77' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text78' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text79' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text80' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text81' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text82' | translate}}</li>
        </ul>
        <p>{{'PRIVACY_POLICY.text83' | translate}}</p>
        <ul>
          <li>{{'PRIVACY_POLICY.text84' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text85' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text86' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text87' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text88' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text89' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text90' | translate}}</li>
        </ul>
        <span class="title-text">{{'PRIVACY_POLICY.text91' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text92' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text93' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text94' | translate}}</span>
        <p><b>{{'PRIVACY_POLICY.text95' | translate}}</b>: {{'PRIVACY_POLICY.text96' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text97' | translate}}</b>: {{'PRIVACY_POLICY.text98' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text99' | translate}}</b>: {{'PRIVACY_POLICY.text100' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text101' | translate}}</b>: {{'PRIVACY_POLICY.text102' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text103' | translate}}</b>: {{'PRIVACY_POLICY.text104' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text105' | translate}}</b>: {{'PRIVACY_POLICY.text106' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text107' | translate}}</b>: {{'PRIVACY_POLICY.text108' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text109' | translate}}</b>: {{'PRIVACY_POLICY.text110' | translate}}
        </p>
        <p><b>{{'PRIVACY_POLICY.text111' | translate}}</b>: {{'PRIVACY_POLICY.text112' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text113' | translate}}</b>: {{'PRIVACY_POLICY.text115' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text116' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text117' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text118' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text119' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text120' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text121' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text122' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text123' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text124' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text125' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text126' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text127' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text128' | translate}}</span>
        <h5>{{'PRIVACY_POLICY.text129' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text130' | translate}}</p>
        <span
          class="title-text">{{'PRIVACY_POLICY.text131' | translate}}</span>
        <h5>{{'PRIVACY_POLICY.text132' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text133' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text134' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text135' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text136' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text137' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text138' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text139' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text140' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text141' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text142' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text143' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text144' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text145' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text146' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text147' | translate}}</h5>
        <p><b>{{'PRIVACY_POLICY.text148' | translate}}</b>: {{'PRIVACY_POLICY.text149' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text150' | translate}}</b>: {{'PRIVACY_POLICY.text151' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text152' | translate}}</b>: {{'PRIVACY_POLICY.text153' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text154' | translate}}</b>: {{'PRIVACY_POLICY.text155' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text156' | translate}}</span>
        <p>{{'PRIVACY_POLICY.text157' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text158' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text159' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text160' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text161' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text162' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text163' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text164' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text165' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text166' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text167' | translate}}</p>
        <ul>
          <li>{{'PRIVACY_POLICY.text168' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text169' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text170' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text171' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text172' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text173' | translate}}</li>
        </ul>
        <p>{{'PRIVACY_POLICY.text174' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text175' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text176' | translate}}</p>
        <ul>
          <li>{{'PRIVACY_POLICY.text177' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text178' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text179' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text180' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text181' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text182' | translate}}</li>
        </ul>
        <p>{{'PRIVACY_POLICY.text183' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text184' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text185' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text186' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text187' | translate}}</span>
        <h5>{{'PRIVACY_POLICY.text188' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text189' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text190' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text191' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text192' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text193' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text194' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text195' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text196' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text197' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text198' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text199' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text200' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text201' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text202' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text203' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text204' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text205' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text206' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text207' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text208' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text209' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text210' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text211' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text212' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text213' | translate}}</p>
        <ul>
          <li>{{'PRIVACY_POLICY.text214' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text215' | translate}}</li>
        </ul>
        <h5>{{'PRIVACY_POLICY.text216' | translate}}</h5>
        <p><b>{{'PRIVACY_POLICY.text217' | translate}}</b>:{{'PRIVACY_POLICY.text218' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text219' | translate}}</b>: {{'PRIVACY_POLICY.text220' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text221' | translate}}</b>: {{'PRIVACY_POLICY.text222' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text223' | translate}}</b>: {{'PRIVACY_POLICY.text224' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text225' | translate}}</b>: {{'PRIVACY_POLICY.text226' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text227' | translate}}</p>
        <ul>
          <li>{{'PRIVACY_POLICY.text228' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text229' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text230' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text231' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text232' | translate}}</li>
        </ul>
        <p><b>{{'PRIVACY_POLICY.text233' | translate}}</b>: {{'PRIVACY_POLICY.text234' | translate}}</p>
        <ul>
          <li>{{'PRIVACY_POLICY.text235' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text236' | translate}}</li>
        </ul>
        <p><b>{{'PRIVACY_POLICY.text237' | translate}}</b>: {{'PRIVACY_POLICY.text238' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text239' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text240' | translate}}</b>: {{'PRIVACY_POLICY.text241' | translate}}</p>
        <p><b>{{'PRIVACY_POLICY.text242' | translate}}</b>: {{'PRIVACY_POLICY.text243' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text244' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text245' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text246' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text248' | translate}} <br>
          {{'PRIVACY_POLICY.text249' | translate}}<br>
          {{'PRIVACY_POLICY.text250' | translate}}<br>
          {{'PRIVACY_POLICY.text251' | translate}}<br>
          {{'PRIVACY_POLICY.text252' | translate}}<br>
          {{'PRIVACY_POLICY.text253' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text254' | translate}}<br>
          {{'PRIVACY_POLICY.text255' | translate}}</p>
        <span class="title-text">{{'PRIVACY_POLICY.text256' | translate}}</span>
        <h5>{{'PRIVACY_POLICY.text257' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text258' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text259' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text260' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text261' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text262' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text263' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text264' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text265' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text266' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text267' | translate}}</p>
        <ul>
          <li>{{'PRIVACY_POLICY.text268' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text269' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text270' | translate}}</li>
        </ul>
        <h5>{{'PRIVACY_POLICY.text271' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text272' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text273' | translate}}</p>
        <ul>
          <li>{{'PRIVACY_POLICY.text274' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text275' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text276' | translate}}</li>
        </ul>
        <p>{{'PRIVACY_POLICY.text277' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text278' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text279' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text280' | translate}}</p>
        <ul>
          <li>{{'PRIVACY_POLICY.text281' | translate}}</li>
          <li>{{'PRIVACY_POLICY.text282' | translate}}</li>
        </ul>
        <p>{{'PRIVACY_POLICY.text283' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text284' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text285' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text286' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text287' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text288' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text289' | translate}}</p>
        <ol>
          <li><b>{{'PRIVACY_POLICY.text290' | translate}}</b>. {{'PRIVACY_POLICY.text291' | translate}}</li>
          <li><b>{{'PRIVACY_POLICY.text292' | translate}}</b>. {{'PRIVACY_POLICY.text293' | translate}}</li>
          <li><b>{{'PRIVACY_POLICY.text294' | translate}}</b>. {{'PRIVACY_POLICY.text295' | translate}}</li>
          <li><b>{{'PRIVACY_POLICY.text296' | translate}}</b>. {{'PRIVACY_POLICY.text297' | translate}}</li>
          <li><b>{{'PRIVACY_POLICY.text298' | translate}}</b>. {{'PRIVACY_POLICY.text299' | translate}}</li>
          <li><b>{{'PRIVACY_POLICY.text300' | translate}}</b>. {{'PRIVACY_POLICY.text301' | translate}}</li>
          <li><b>{{'PRIVACY_POLICY.text302' | translate}}</b>. {{'PRIVACY_POLICY.text303' | translate}}</li>
          <li><b>{{'PRIVACY_POLICY.text304' | translate}}</b>. {{'PRIVACY_POLICY.text305' | translate}}</li>
          <li><b>{{'PRIVACY_POLICY.text306' | translate}}</b>. {{'PRIVACY_POLICY.text307' | translate}}</li>
          <li><b>{{'PRIVACY_POLICY.text308' | translate}}</b> {{'PRIVACY_POLICY.text309' | translate}}</li>
        </ol>
        <h5>{{'PRIVACY_POLICY.text310' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text311' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text312' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text313' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text314' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text315' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text316' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text317' | translate}} <br>
          {{'PRIVACY_POLICY.text318' | translate}} <br>
          {{'PRIVACY_POLICY.text319' | translate}} <br>
          {{'PRIVACY_POLICY.text320' | translate}}</p>
        <h5>{{'PRIVACY_POLICY.text321' | translate}}</h5>
        <p>{{'PRIVACY_POLICY.text322' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text323' | translate}} <br>
          {{'PRIVACY_POLICY.text324' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text325' | translate}}</p>
        <p>{{'PRIVACY_POLICY.text326' | translate}} <br>
          {{'PRIVACY_POLICY.text327' | translate}}</p>
      </div>
    </div>
  </div>
</div>

